import { useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import { TextMedium, TextRegular } from 'UiKit/typography';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { AlertOutlineIcon, CloseIcon, PencilOutlineIcon } from 'Asset/icon';
import AttachmentImage from 'Component/attachment-image';
import { useTalkingPointUpsertState } from 'View/brief-live/state/talkingPointState';
import { Condition } from 'Component/others';

import { ICON_BTN_PROPS } from '../const';
import ProductItemEditPanel from '../product-item-edit-panel';
import ProductManualEditPanel from '../product-manual-edit-panel';

import styles from './styles.module.css';

const ProductItem = ({ product, onDelete, onEdit, t }) => {
  const { updateState } = useTalkingPointUpsertState();
  const handleOpenPreview = (images) => updateState({ isOpenImagePreview: true, selectedImagePreview: images });
  const images = product?.image ? [{ url: product?.image }] : [];
  const savedNote = product?.note || '';

  const [isEditing, setIsEditing] = useState(false);
  const [noteValue, setNoteValue] = useState(savedNote);

  const handleEditClick = () => {
    setNoteValue(savedNote);
    setIsEditing(true);
  };

  const handleCancel = () => {
    setNoteValue(savedNote);
    setIsEditing(false);
  };

  const handleSaveNote = () => {
    onEdit(product, { note: noteValue });
    setIsEditing(false);
  };

  const handleSaveManual = (updatedProduct) => {
    onEdit(product, updatedProduct);
    setIsEditing(false);
  };

  if (isEditing && product?.isManual) {
    return (
      <Box className={styles['product-item']}>
        <ProductManualEditPanel product={product} onSave={handleSaveManual} onCancel={handleCancel} onDelete={() => onDelete(product)} t={t} />
      </Box>
    );
  }

  return (
    <Box className={styles['product-item']}>
      <Flex className={styles['product-item__row']}>
        <Box className={styles['product-item__thumbnail']}>
          <AttachmentImage images={images} onOpenPreview={handleOpenPreview} />
        </Box>
        <Box className={styles['product-item__info']}>
          <TextMedium className={styles['product-item__label']}>{product?.label}</TextMedium>
          <TextRegular className={styles['product-item__value']}>{product?.value}</TextRegular>
        </Box>
        <Condition statement={!isEditing}>
          <Flex className={styles['product-item__actions']}>
            <ButtonOutline {...ICON_BTN_PROPS} onClick={handleEditClick}>
              <PencilOutlineIcon width="16px" height="16px" />
            </ButtonOutline>
            <ButtonOutline {...ICON_BTN_PROPS} color="#dc2626" onClick={() => onDelete(product)}>
              <CloseIcon width="16px" height="16px" />
            </ButtonOutline>
          </Flex>
        </Condition>
      </Flex>
      <Condition
        statement={isEditing}
        fallback={
          <Condition statement={product?.note}>
            <Box className={styles['product-item__note--container']}>
              <AlertOutlineIcon width="14px" height="14px" />
              <TextRegular className={styles['product-item__note']}>{product?.note}</TextRegular>
            </Box>
          </Condition>
        }
      >
        <ProductItemEditPanel
          noteValue={noteValue}
          savedNote={savedNote}
          setNoteValue={setNoteValue}
          onSave={handleSaveNote}
          onCancel={handleCancel}
          onDelete={() => onDelete(product)}
          t={t}
        />
      </Condition>
    </Box>
  );
};

export default ProductItem;
